export default "__VITE_ASSET__JmJ71j1m__"